export default __webpack_public_path__ + "static/media/coingecko.c8806f50.png";